import {
  SegmentedControl,
  visibilityHideIcon,
  visibilityShowIcon,
} from "@repo/skapa";
import { t } from "@repo/translation";

import { useSettings } from "../settings/SettingsProvider";
import {
  STORAGE_KEY,
  getStorageItem,
  setStorageItem,
} from "../storage/storage";

export const CUSTOMER_MODE_KEY = "saleslead-customer-mode";

export const setCustomerModeToStorage = (toggle: boolean) => {
  setStorageItem(STORAGE_KEY.CUSTOMER_MODE_KEY, JSON.stringify(toggle));

  // Fire a custom event so other React roots/fragments update immediately
  window.dispatchEvent(new Event("customerModeChange"));
};

export const getCustomerModeFromStorage = () => {
  const res = getStorageItem(STORAGE_KEY.CUSTOMER_MODE_KEY);

  if (!res) {
    return true;
  }
  return JSON.parse(res) as boolean;
};

export const CustomerModeToggle = () => {
  const { customerMode, setCustomerMode } = useSettings();
  const active = customerMode ? 1 : 0;

  const items = [
    {
      ssrIcon: visibilityShowIcon,
      label: "Show all data",
      title: t("action.show_all_data"),
    },
    {
      ssrIcon: visibilityHideIcon,
      label: "Hide sensitive data",
      title: t("action.hide_sensitive_data"),
    },
  ];

  const handleClick = (
    e: React.MouseEvent<HTMLButtonElement>,
    index: number
  ) => {
    setCustomerMode(index === 1);
  };

  return (
    <SegmentedControl
      size="small"
      activeIndex={active}
      items={items}
      onClick={handleClick}
      iconOnly
    />
  );
};
